// Microphone -> 16 kHz mono 16-bit PCM chunks (~100 ms each) for server-side speech recognition.
// The stream and audio graph stay open after the first press so Safari doesn't ask for permission every time.

const WORKLET = `
class Pcm16 extends AudioWorkletProcessor {
  constructor() { super(); this.on = false; this.acc = 0; this.buf = []; this.port.onmessage = (e) => { this.on = e.data; if (!e.data) this.flush(); }; }
  flush() { if (this.buf.length) { const a = new Int16Array(this.buf); this.buf = []; this.port.postMessage(a.buffer, [a.buffer]); } }
  process(inputs) {
    const ch = inputs[0] && inputs[0][0];
    if (!this.on || !ch) return true;
    // naive decimation with averaging; speech recognition doesn't need better than this
    const step = sampleRate / 16000;
    for (let i = 0; i < ch.length; i++) {
      this.acc += 1;
      if (this.acc >= step) {
        this.acc -= step;
        const s = Math.max(-1, Math.min(1, ch[i]));
        this.buf.push(s < 0 ? s * 0x8000 : s * 0x7fff);
      }
    }
    if (this.buf.length >= 1600) this.flush();
    return true;
  }
}
registerProcessor('pcm16', Pcm16);
`;

export class Mic {
  private ctx?: AudioContext;
  private node?: AudioWorkletNode;
  onChunk: (pcm: ArrayBuffer) => void = () => {};

  static supported() {
    return !!(typeof navigator.mediaDevices?.getUserMedia === 'function' && (window as any).AudioWorkletNode && window.isSecureContext);
  }

  // must be called from a user gesture (pointerdown) so iOS lets audio start
  async start() {
    if (!this.ctx) {
      const ctx = new AudioContext();
      this.ctx = ctx;
      const url = URL.createObjectURL(new Blob([WORKLET], { type: 'text/javascript' }));
      const [stream] = await Promise.all([
        navigator.mediaDevices.getUserMedia({ audio: { channelCount: 1, echoCancellation: true, noiseSuppression: true, autoGainControl: true } }),
        ctx.audioWorklet.addModule(url),
      ]);
      const node = new AudioWorkletNode(ctx, 'pcm16');
      node.port.onmessage = (e) => this.onChunk(e.data);
      ctx.createMediaStreamSource(stream).connect(node);
      // a silent path to the speakers keeps Safari pulling audio through the worklet
      const mute = ctx.createGain(); mute.gain.value = 0; node.connect(mute).connect(ctx.destination);
      this.node = node;
    }
    if (this.ctx.state !== 'running') await this.ctx.resume();
    this.node!.port.postMessage(true);
  }

  stop() { this.node?.port.postMessage(false); }
}
